<template>
  <div class="cost main-content">
    <el-card class="p-t-hg">
      <div class="collapse-content">
        <base-form
          v-model="baseData"
          :options="options"
          ref="baseData"
          label-width="100px"
        ></base-form>

        <div class="collapse-content">
          <vxe-grid
            border
            show-overflow
            resizable
            ref="table"
            class="vxe-table-element"
            size="mini"
            align="left"
            :auto-resize="true"
            :data="tableData"
            :columns="column"
            :max-height="$store.state.app.tableHeight"
            :toolbar="{}"
            :valid-config="{ autoPos: true, message: 'inline' }"
          >
            <template v-slot:buttons>
              <vxe-button
                @click="exportFile()"
                type="primary"
                icon="el-icon-upload"
                class="vxe-btn-primary"
                >{{ $t('costDetailsList.router.export') }}</vxe-button
              >
            </template>
          </vxe-grid>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  // import DictSelect from '@/components/DictSelect';
  // import inputNumber from '@/components/form-item/input-number';
  export default {
    name: 'costDetails',
    components: {
      baseForm,
      // DictSelect,
      // inputNumber,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      options() {
        return [
          //结算期间
          {
            prop: 'settlementDateStart',
            label: this.$t('costDetailsList.column.settlementDateStart'),
            type: 'date',
            disabled: true,
          },
          {
            prop: 'settlementDateEnd',
            label: this.$t('costDetailsList.column.settlementDateEnd'),
            type: 'date',
            disabled: true,
          },
        ];
      },
      column() {
        return [
          { type: 'checkbox', width: 50 },
          {
            //序号
            type: 'seq',
            width: 80,
            title: this.$t('costDetailsList.column.sortNo'),
          },
          {
            //商品小类
            field: 'productName',
            title: this.$t('costDetailsList.column.productName'),
            width: '140',
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          //单位
          {
            field: 'productUnit',
            title: this.$t('costDetailsList.column.productUnit'),
            visible: true,
            width: 140,
          },
          //结算日期
          {
            field: 'settlementDate',
            title: this.$t('costDetailsList.column.settlementDate'),
            visible: true,
            width: 140,
          },
          //期初累计领用数量
          {
            field: 'openingRecipientsCount',
            title: this.$t('costDetailsList.column.openingRecipientsCount'),
            visible: true,
            width: 120,
          },
          //期初累计耗用数量
          {
            field: 'openingConsumptionCount',
            title: this.$t('costDetailsList.column.openingConsumptionCount'),
            visible: true,
            width: 120,
          },
          //期初差异数量
          {
            field: 'openingDiffCount',
            title: this.$t('costDetailsList.column.openingDiffCount'),
            visible: true,
            width: 110,
          },
          //期初差异金额
          {
            field: 'openingDiffAmount',
            title: this.$t('costDetailsList.column.openingDiffAmount'),
            visible: true,
            width: 120,
          },
          //本期实际领用数量
          {
            field: 'currentRecipientsCount',
            title: this.$t('costDetailsList.column.currentRecipientsCount'),
            visible: true,
            width: 120,
          },
          //本期实际耗用数量
          {
            field: 'currentConsumptionCount',
            title: this.$t('costDetailsList.column.currentConsumptionCount'),
            visible: true,
            width: 140,
          },
          //本期差异数量
          {
            field: 'currentDiffCount',
            title: this.$t('costDetailsList.column.currentDiffCount'),
            visible: true,
            width: 140,
          },
          //本期平均单价
          {
            field: 'currentCostPrice',
            title: this.$t('costDetailsList.column.currentCostPrice'),
            visible: true,
            width: 140,
          },
          //本期差异金额
          {
            field: 'currentDiffAmount',
            title: this.$t('costDetailsList.column.currentDiffAmount'),
            visible: true,
            width: 140,
          },
          //期末累计领用数量
          {
            field: 'endRecipientsCount',
            title: this.$t('costDetailsList.column.endRecipientsCount'),
            visible: true,
            width: 140,
          },
          //期末累计耗用数量
          {
            field: 'endConsumptionCount',
            title: this.$t('costDetailsList.column.endConsumptionCount'),
            visible: true,
            width: 140,
          },
          //期末差异数量
          {
            field: 'endDiffCount',
            title: this.$t('costDetailsList.column.endDiffCount'),
            visible: true,
            width: 140,
          },
          //期末差异金额
          {
            field: 'endDiffAmount',
            title: this.$t('costDetailsList.column.endDiffAmount'),
            visible: true,
            width: 140,
          },
          {
            //操作人
            field: 'createPersonNo',
            title: this.$t('costDetailsList.column.createPersonNo'),
            visible: true,
            width: 140,
          },
          {
            //业务部门
            field: 'businessDepartmentCode',
            title: this.$t('costDetailsList.column.businessDepartmentCode'),
            visible: true,
            width: 140,
          },
          {
            //公司
            field: 'businessCompanyCode',
            title: this.$t('costDetailsList.column.businessCompanyCode'),
            visible: true,
            width: 140,
          },
        ];
      },
    },
    data() {
      return {
        load: false,
        baseData: {
          settlementDateStart: null, //结算日期起
          settlementDateEnd: null, //结算日期止
        },
        tableData: [], //列表数据
      };
    },
    methods: {},
  };
</script>
